import { Theme, styled } from '@mui/material'
import Slider from '@mui/material/Slider'
import { colors } from '@theme/variables'

export const StyledSlider = styled(Slider)(({ theme }: { theme: Theme }) => ({
  margin: '13px 0',
  padding: '1px',
  zIndex: 2,
  position: 'relative',

  '& .MuiSlider-thumb': {
    width: 18,
    height: 18,
    zIndex: 1,
    backgroundColor: colors.primary,
    borderRadius: '50%',

    '&:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'none',
    },

    '&:after': {
      content: '""',
      position: 'absolute',
      left: '50%',
      top: '-8px',
      width: '0',
      height: '0',
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderTop: '16px solid transparent',
      zIndex: -1,
      borderBottom: `16px solid ${colors.primary}`,
    },

    '&:before': {
      content: '""',
      position: 'absolute',
      height: 8,
      width: 8,
      borderRadius: '50%',
      backgroundColor: '#fff',
      boxShadow: 'none',
    },
  },

  '& .MuiSlider-rail, & .MuiSlider-track': {
    backgroundColor: '#F1F1F1',
    height: '6px',
    opacity: 1,
  },
}))
